var picocolors_browser = { exports: {} };
export {
  picocolors_browser as __module
};
//# sourceMappingURL=picocolors.browser.js.map
